// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CloseButton_closeButton__Zeznz","closeIcon":"CloseButton_closeIcon___1pDO"};